import "../../css/doradoDerbyStyles.css";
import "../../css/pelagicTunaStyles.css";
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import React, {Component} from "react";
import { Redirect } from "react-router-dom";
import ReactPlayer from 'react-player';
import Countdown from 'react-countdown-now';
import moment from 'moment';
import TelevisionBreakpoint from "../../components/responsive_utilities/television_breakpoint";
import DesktopBreakpoint from "../../components/responsive_utilities/desktop_breakpoint";
import TabletBreakpoint from "../../components/responsive_utilities/tablet_breakpoint";
import PhoneBreakpoint from "../../components/responsive_utilities/phone_breakpoint";
import { TournamentDetailsPhone} from "../../components/CompsPhone/TournamentDetailsPhone";
import { SponsorsScroller} from "../../components/SponsorsScroller";
import { SponsorsScrollerTv} from "../../components/SponsorsScrollerTv";
import { SpeciesScoresTVList } from "../../components/CompsTv/SpeciesScoresTVList";
import { SpeciesScoresDTList } from "../../components/SpeciesScoresDTList";
import { SpeciesScoresTabList } from "../../components/SpeciesScoresTabList";
import { TideChartPhone } from "../../components/CompsPhone/TideChartPhone";
var Sound = require('react-sound').default; 


const dragSound = require('../../media/drag.wav');
const caboBkg = require('../../media/bkgImage2.png');
const sponsorLogos = [
  'https://firebasestorage.googleapis.com/v0/b/sancochero-51ea9.appspot.com/o/Flor-De-Cana-Logo.jpg?alt=media&token=171f8049-1908-4f64-a6fe-98715d3fde4a',
  'https://firebasestorage.googleapis.com/v0/b/sancochero-51ea9.appspot.com/o/Si%20Como%20No.JPG?alt=media&token=cbb5fffe-f8e9-4091-9a63-d1dde5eaf8e5',
  'https://firebasestorage.googleapis.com/v0/b/sancochero-51ea9.appspot.com/o/radio2.png?alt=media&token=f56a34fd-fada-4478-86b7-f53016f84d93',
  'https://firebasestorage.googleapis.com/v0/b/sancochero-51ea9.appspot.com/o/heinekin_logo.jpg?alt=media&token=a417b9d8-9f2e-4154-bdae-3e88608ba44a',
  'https://firebasestorage.googleapis.com/v0/b/sancochero-51ea9.appspot.com/o/sponsors_logos%2Foffshorelifestylelogo.png?alt=media&token=eae5a250-ce26-495e-96c4-8088f45ff1e6'
];
var firebase = require('firebase/app');
require('firebase/database');

class DoradoDerby extends Component {
  constructor() {
    super();
    this.state = {
      tournament: [],
      tourDay1: '',
      tourDay2: '',
      tourDay3: '',
      tourDay4: '',
      countDownDate: '',
      buttonStatus: 'current',
      buttonStatus1: 'notCurrent',
      buttonStatus2: 'notCurrent',
      buttonStatus3: 'notCurrent',
      buttonStatus4: 'notCurrent',
      tournamentLogo: '',
      tournamentName: '',
      boats: [],
      anglersRaw: {},
      species: [],
      speciesRaw: {},
      boatsRaw: {},
      logs: [],
      logsOne: [],
      logsTwo: [],
      logsThree: [],
      logsFour: [],
      fishLogs: [],
      hookups: [],
      hps: [],
      boatLogs: [],
      boatTotals: [],
      boatTotalsOne: [],
      boatTotalsTwo: [],
      boatTotalsThree: [],
      boatTotalsFour: [],
      boatScores: [],
      boatScoresArray: [],
      showAll: true,
      showDay1: false,
      showDay2: false,
      showDay3: false,
      showDay4: false,
      newLog: false,
      newItem: false,
      playing: 'STOPPED',
      vidPlaying: true,
      loading: true,
      newFishLog: [],
      vidList: [],
      currentVideo: '',
      boardId: '',
      boardName: '',
      videoVis: 'visible',
      displayVis: 'inline',
      loadingVis: 'none',
      loadingVis2: 'inline',
      speciesPoints: [],
      boatFishLogs: [],
      redirect: false
    };
    this.baseRef = firebase.database().ref('/');
    this.ref = firebase.database().ref('tournaments');
    this.tourRef = firebase.database().ref('tournaments/-LN_Yl1Vk2sLPsRg38V6');
    this.feedRef = firebase.database().ref('tournaments/-LN_Yl1Vk2sLPsRg38V6');
  }
  
  componentWillMount() {
    this.tourRef.on('value', this.handleTournamentUpdate);
    this.tourRef.child('/').on('child_changed', this.redirectToHome);
    this.tourRef.child('fishLogs').on('child_added', this.handleFishLogAdded);
    this.tourRef.child('fishLogs').on('child_changed', this.handleFishLogChanged);
    this.baseRef.child('refresh').on('child_changed', this.reloadPage);
    this.feedRef.child('videos').on('child_changed', this.handleFeedUpdate);
    
  }
  
  componentDidMount() {
    window.addEventListener("keyup", this.keyHandling);
    this.baseRef.child('refreshPlaylist').on('child_changed', this.reloadPlaylist);
    this.fetchVideosList();
  }
  
  keyHandling = (e) => {
    if(e.keyCode === 179) {
      this.setState({
        vidPlaying: !this.state.vidPlaying
      })
    } else if(e.keyCode === 227) {
      this.previousVideo(this.state.currentVideo)
    } else if(e.keyCode === 228) {
      this.nextVideo(this.state.currentVideo)
    } else {
      return
    }
  }
  
  reloadPage = () => {
    window.location.reload(true);
  }

  redirectToHome = (snapshot, last) => {
    if(!snapshot.val()) {
      this.setState({redirect: true})
    }
  }

  reloadPlaylist = () => {
		console.log('Reloading')
    this.fetchVideosList();
  }

  handleFeedUpdate = (snapshot) => {
    if(snapshot.val().feedActive) {
      this.setState({
        currentVideo: snapshot.val().videoUrl
      })
    } else {
      this.setState({
        currentVideo: this.state.vidList[0]
      })
    }
  }

  fetchVideosList() {
		const API = 'AIzaSyDPOAO90Hmjyg73TusAFE4-OfbaDIkfkwU'
		const channelID = 'PLBE2HTUQ9kZvSHNEPWDTEygVBsVI0WkKL'
		const results = 20;
		var vidList = [];
		
		var finalURL = `https://www.googleapis.com/youtube/v3/playlistItems?part=snippet&playlistId=${channelID}&maxResults=${results}&key=${API}`;
		
		fetch(finalURL)
      .then((response) => response.json())
      .then((resp) => { 
				resp.items.forEach((item) => {
					vidList.push('https://youtu.be/' + item.snippet.resourceId.videoId)
				})
				this.setState({
					vidList,
					currentVideo: vidList[0],
				})
      })
      .catch((error) => {
        console.error(error);
      });
	}
  
  handleTournamentUpdate = (snapshot) => {
    if(snapshot.val().fishLogs) {
      var fishLogsArray = Object.entries(snapshot.val().fishLogs);
    }
    var fishLogsList = [];
    var hookupsList = [];
    var speciesArray = Object.entries(snapshot.val().species);
    var speciesList = [];
    var boatsArray = Object.entries(snapshot.val().boats);
    var boatsList = [];
    if(fishLogsArray) {
      fishLogsArray.forEach((log) => {
        fishLogsList.push({
          id: log[0],
          boatId: log[1].boatId,
          boatName: log[1].boatName,
          boatThm: log[1].photoUrl,
          speciesId: log[1].speciesId,
          speciesName: log[1].speciesName,
          anglerId: log[1].anglerId,
          anglerName: log[1].anglerName,
          lbs: log[1].fishLbs,
          hookedupDate: log[1].hookedupDate,
          catchDate: log[1].catchDate,
          status: log[1].status
        });
        if (log[1].status === 'hooked up'){
          hookupsList.push ({
            id: log[0],
            boatId: log[1].boatId,
            boatName: log[1].boatName,
            boatThm: log[1].photoUrl,
            speciesId: log[1].speciesId,
            speciesName: log[1].speciesName,
            anglerId: log[1].anglerId,
            anglerName: log[1].anglerName,
            lbs: log[1].fishLbs,
            hookedupDate: log[1].hookedupDate,
            status: log[1].status
          })
        }
      })
    }
    
    speciesArray.forEach((specie) => {
      speciesList.push({
        id: specie[0],
        name: specie[1].name,
        points: specie[1].points,
        scoreType: specie[1].scoreType,
        speciesImageUri: specie[1].speciesImageUri
      })
    })
    
    boatsArray.forEach((boat) => {
      new Image().src = boat[1].photoUrl;
      boatsList.push({
        id: boat[0],
        name: boat[1].name,
        photoURL: boat[1].photoUrl,
      })
    })
    
    var countDownDate = moment.utc(new Date(snapshot.val().day1Date)).format('LLL');
    
    var tournament = {
      tournamentId: snapshot.key,
      tournamentName: snapshot.val().name,
      tournamentLogo: snapshot.val().logoUri,
      venue: snapshot.val().venue,
      captMeetingTime: snapshot.val().captMeetingTime,
      captMeetingLoc: snapshot.val().captMeetingLoc,
      tourDay1: snapshot.val().day1Date,
      tourDay2: snapshot.val().day2Date,
      tourDay3: snapshot.val().day3Date,
      tourDay4: snapshot.val().day4Date,
      anglersRaw: snapshot.val().anglers,
      boatsRaw: snapshot.val().boats,
    }
    
    this.setState({
      tournamentId: snapshot.key,
      tournamentName: snapshot.val().name,
      tournamentLogo: snapshot.val().logoUri,
      tourDay1: snapshot.val().day1Date,
      tourDay2: snapshot.val().day2Date,
      tourDay3: snapshot.val().day3Date,
      tourDay4: snapshot.val().day4Date,
      species: speciesList, 
      speciesRaw: snapshot.val().species,
      anglersRaw: snapshot.val().anglers,
      boatsRaw: snapshot.val().boats,
      boats: boatsList,
      hps: hookupsList,
      newItem: true,
      fishLogs: this.sortFishLogs(fishLogsList),
      countDownDate,
      tournament
    });
    setTimeout(() => {
      this.getBoats();
    }, 1000);
  }
  
  isEmpty(obj) {
    for(var key in obj) {
        if(obj.hasOwnProperty(key))
            return false;
    }
    return true;
  }
  
  
  sortFishLogs(logs){
    logs.sort(function(a,b){
      var c = new Date(a.catchDate);
      var d = new Date(b.catchDate);
      return c-d;
    });
    
    logs.reverse();
    return logs
  }
  
  handleFishLogAdded = (snapshot) => {
    if (!this.state.newItem) return;
    var fishLogs = this.state.fishLogs;
    if(snapshot.val().catchDate) {
      var cd = this.formatDate(snapshot.val().catchDate);
    } else {
      var cd = null;
    }
    if(snapshot.val().hookedupDate) {
      var hd = this.formatDate(snapshot.val().hookedupDate);
    } else {
      var hd = null;
    }
      fishLogs.unshift({
        id: snapshot.key,
        boatId: snapshot.val().boatId,
        boatName: snapshot.val().boatName,
        speciesId: snapshot.val().speciesId,
        speciesName: snapshot.val().speciesName,
        lbs: snapshot.val().fishLbs,
        anglerId: snapshot.val().anglerId,
        anglerName: snapshot.val().anglerName,
        photoUrl: snapshot.val().photoUrl,
        status: snapshot.val().status,
        hookedupDate: hd,
        catchDate: cd,
        });
      this.setState({
        playing: 'PLAYING',
        newLog: true,
        videoVis: 'hidden',
        displayVis: 'none',
        newFishLog: {
          boatId: snapshot.val().boatId,
          boatName: snapshot.val().boatName,
          photoUrl: snapshot.val().photoUrl,
          anglerName: snapshot.val().anglerName,
          anglerId: snapshot.val().anglerId,
          speciesId: snapshot.val().speciesId,
          speciesName: snapshot.val().speciesName,
          fishLbs: snapshot.val().fishLbs,
          status: snapshot.val().status,
          hookedupDate: hd,
          catchDate: cd,
        }
      })
    
    setTimeout(function() { this.setState({playing: 'STOPPED'}); }.bind(this), 4000);
    setTimeout(function() { this.setState({newLog: false}); }.bind(this), 10000);
    setTimeout(function() { this.setState({videoVis: 'visible', displayVis: 'inline'}); }.bind(this), 10000);
  }
  
  sortLogs(logs){
    logs.sort(function(a,b){
      var c = new Date(a.catchDate);
      var d = new Date(b.catchDate);
      return c-d;
    });
    
    logs.reverse();
    this.getBoats();
  }

  redirectToHome = (snapshot, last) => {
    if(!snapshot.val()) {
      this.setState({redirect: true})
    }
  }

  
  handleFishLogChanged = (snapshot, last) => {
    var logs = this.state.fishLogs;
    if(snapshot.val().catchDate) {
      var cd = this.formatDate(snapshot.val().catchDate);
    } else {
      var cd = null;
    }
    if(snapshot.val().hookedupDateDate) {
      var hd = this.formatDate(snapshot.val().hookedupDateDate);
    } else {
      var hd = null;
    }
    logs.map(log => {
      if(log.id === snapshot.key) {
        log.lbs = snapshot.val().fishLbs;
        log.boatId = snapshot.val().boatId;
        log.boatName = snapshot.val().boatName;
        log.speciesId = snapshot.val().speciesId;
        log.speciesName = snapshot.val().speciesName;
        log.anglerId = snapshot.val().anglerId;
        log.anglerName = snapshot.val().anglerName;
        log.catchDate = this.formatDate(snapshot.val().catchDate);
        log.clipUrl = snapshot.val().clipUrl;
        log.status = snapshot.val().status;
      }
    });
    this.setState({
      fishLogs:logs,
      playing: 'PLAYING',
      newLog: true,
      videoVis: 'hidden',
      displayVis: 'none',
      newFishLog: {
        boatId: snapshot.val().boatId,
        boatName: snapshot.val().boatName,
        photoUrl: snapshot.val().photoUrl,
        anglerName: snapshot.val().anglerName,
        anglerId: snapshot.val().anglerId,
        speciesId: snapshot.val().speciesId,
        speciesName: snapshot.val().speciesName,
        fishLbs: snapshot.val().fishLbs,
        status: snapshot.val().status,
        hookedupDateDate: hd,
        catchDate: cd,
        }
    })
    this.getBoats();
    setTimeout(function() { this.setState({playing: 'PAUSED'}); }.bind(this), 4000);
    setTimeout(function() { this.setState({newLog: false}); }.bind(this), 10000);
    setTimeout(function() { this.setState({videoVis: 'visible', displayVis: 'inline'}); }.bind(this), 10000);
  }
  
  getBoats() {
    var logs = this.state.fishLogs;
    var boats = this.state.boats;
    var boatLogs = [];
    var boatLogsOne = [];
    var boatLogsTwo = [];
    var boatLogsThree = [];
    var boatLogsFour = [];
    boats.forEach((boat) => {
      var boatFish = [];
      var boatFishOne = [];
      var boatFishTwo = [];
      var boatFishThree = [];
      var boatFishFour = [];
      
      //Get FishLog for each Boat
      logs.forEach((fishLog) => {
        if(!fishLog.catchDate){
          return
        }
        if(boat.id === fishLog.boatId){
          if(fishLog.length !== 0) {
            boatFish.push(fishLog);
          }
        }
        if(this.state.tourDay1 === fishLog.catchDate.substring(0,10)) {
          if(boat.id === fishLog.boatId){
            if(fishLog.length !== 0) {
              boatFishOne.push(fishLog);
            }
          }
        } else if(this.state.tourDay2 === fishLog.catchDate.substring(0,10)) {
          
          if(boat.id === fishLog.boatId){
            if(fishLog.length !== 0) {
              boatFishTwo.push(fishLog);
            }
          }
          
        } else if(this.state.tourDay3 === fishLog.catchDate.substring(0,10)) {
          if(boat.id === fishLog.boatId){
            if(fishLog.length !== 0) {
              boatFishThree.push(fishLog);
            }
          }
        } else if(this.state.tourDay4 === fishLog.catchDate.substring(0,10)) {
          if(boat.id === fishLog.boatId){
            if(fishLog.length !== 0) {
              boatFishFour.push(fishLog);
            }
          }
        }
      });
      
      if(boatFish.length !== 0) {
        boatFish.sort(function(a, b) {
            var dateA = new Date(a.catchDate), dateB = new Date(b.catchDate);
            return dateA - dateB;
        });
        var lastFishInt = (boatFish.length - 1);
        var lastFishTime = boatFish[lastFishInt].catchDate;
        boatLogs.push({
          boatId: boat.id,
          boatName: boat.name,
          boatThm: boat.photoURL,
          boatCaughtFish: boatFish,
          lastFishTime:  lastFishTime
        });
      }
      if(boatFishOne.length !== 0) {
        var lastFishIntOne = (boatFishOne.length - 1);
        var lastFishTimeOne = boatFishOne[lastFishIntOne].catchDate;
        boatLogsOne.push({
          boatId: boat.id,
          boatName: boat.name,
          boatThm: boat.photoURL,
          boatCaughtFish: boatFishOne,
          lastFishTime:  lastFishTimeOne
        });
      } 
      
      if(boatFishTwo.length !== 0) {
        var lastFishIntTwo = (boatFishTwo.length - 1);
        var lastFishTimeTwo = boatFishTwo[lastFishIntTwo].catchDate;
        boatLogsTwo.push({
          boatId: boat.id,
          boatName: boat.name,
          boatThm: boat.photoURL,
          boatCaughtFish: boatFishTwo,
          lastFishTime:  lastFishTimeTwo
        });
      }
      if(boatFishThree.length !== 0) {
        var lastFishIntThree = (boatFishThree.length - 1);
        var lastFishTimeThree = boatFishThree[lastFishIntThree].catchDate;
        boatLogsThree.push({
          boatId: boat.id,
          boatName: boat.name,
          boatThm: boat.photoURL,
          boatCaughtFish: boatFishThree,
          lastFishTime:  lastFishTimeThree
        });
      }
      
      if(boatFishFour.length !== 0) {
        var lastFishIntFour = (boatFishFour.length - 1);
        if(lastFishIntFour) {
          var lastFishTimeFour = boatFishFour[lastFishIntFour].catchDate;
          boatLogsFour.push({
            boatId: boat.id,
            boatName: boat.name,
            boatThm: boat.photoURL,
            boatCaughtFish: boatFishFour,
            lastFishTime: lastFishTimeFour
          });
        }
      }
    });
    
    var bTotals = this.getBoatTotals(boatLogs);
    var bTotalsOne = this.getBoatTotals(boatLogsOne);
    var bTotalsTwo = this.getBoatTotals(boatLogsTwo);
    var bTotalsThree = this.getBoatTotals(boatLogsThree);
    var bTotalsFour = this.getBoatTotals(boatLogsFour);
    
    this.setState({
      logs: boatLogs,
      boatScores: this.scoreSortFilter(bTotals),
      boatScoresOne: this.scoreSortFilter(bTotalsOne),
      boatScoresTwo: this.scoreSortFilter(bTotalsTwo),
      boatScoresThree: this.scoreSortFilter(bTotalsThree),
      boatScoresFour: this.scoreSortFilter(bTotalsFour),
    })
    setTimeout(this.toggleLoading, 3000)
  }

  toggleLoading = () => {
    this.setState({
        loading: false,
        loadingVis: 'inline',
        loadingVis2: 'none',
      });
  }

  getBoatTotals(bLogs) {
    var boatTotals = [];
    bLogs.forEach((boatLog) => {
      var logs = boatLog.boatCaughtFish;
      var sps = this.state.species;
      var boatCounts = [];
      var boatPoints = [];
      var boatLbsPoints = [];
      var boatTotal = '';
      
      sps.forEach((specie) => {
        var speciesId = specie.id
        var speciesName = specie.name;
        var speciesPoints = specie.points;
        var scoreType = specie.scoreType;
        var speciesCount = [];
        var speciesScores = 0;
         
        if (scoreType === 'QTY'){
          logs.forEach((log) => {
           
            if(specie.id === log.speciesId) {
              speciesCount.push(log.id);
            }
          }); 
          var count = speciesCount.length;
          var points = parseFloat(count * speciesPoints);
          var totalPoints = (points + speciesScores)
          boatCounts.push({
            id: speciesId,
            boatName: boatLog.boatName,
            boatThm: boatLog.boatThm,
            speciesName: speciesName,
            speciesCount: speciesCount.length,
            speciesPoints: totalPoints
          });
          boatPoints.push(totalPoints);
        }
        if (scoreType === 'LBS'){
          logs.forEach((log) => {
            if(specie.id === log.speciesId) {
              speciesCount.push(log.id);
              speciesPoints = speciesPoints * log.lbs;
            }
          });
          if(speciesCount.length > 0) {
            boatCounts.push({
            id: speciesId,
            boatName: boatLog.boatName,
            boatThm: boatLog.boatThm,
            speciesName: speciesName,
            speciesCount: speciesCount.length,
            speciesPoints
          });
          }
          boatLbsPoints.push(totalPoints);
        }
      });
      boatTotal = boatPoints.reduce(function(sum, value) {
        return sum + value;
      }, 0);
      boatTotals.push({
        id: boatLog.boatId,
        boatName: boatLog.boatName,
        boatThm: boatLog.boatThm,
        speciesCounts: boatCounts,
        total: boatTotal,
        lastFishTime: this.formatDate(boatLog.lastFishTime)
      })
    })
    return boatTotals
  }

  scoreSortFilter(boatScores) {
    Array.prototype.sortOn = function(key, key2){
      this.sort(function(a, b){
          if(a[key] < b[key]){
              return -1;
          }else if(a[key] > b[key]){
              return 1;
          } else {
            if(a[key2] > b[key2]){
              return -1;
            }else if(a[key2] < b[key2]){
              return 1;
            }
          }
          return 0;
      });
    }
    
    boatScores.sortOn("total", "lastFishTime");
    boatScores.reverse();
    
    function isNumber(obj) {
      return obj!== undefined && typeof(obj) === 'number' && !isNaN(obj);
    }

    function filterByTotal(item) {
      if (isNumber(item.total)) {
        return true;
      } 
      return false; 
    }
    var boatScoresArray = boatScores.filter(filterByTotal);
    
    var rank = 1;
    var bScores = [];
    boatScoresArray.forEach((boat) => {
      bScores.push({
        rank: rank++,
        boat: boat
      })
    })
    return bScores;  
  }

  formatDate(date) {
    var options = {
      month: 'short', day: 'numeric',
      hour: 'numeric', minute: 'numeric',
      hour12: true,
      timeZone: 'America/Mazatlan',
    };
    var newDate = new Date(date);
    var formattedDate = new Intl.DateTimeFormat('en-US', options).format(newDate);

    return formattedDate;
  }

  catchDate(date) {
    var catchDate = new Date(date)
    var hour = catchDate.getHours();
    var secs = catchDate.getSeconds();
    var ampm = hour >= 12 ? 'PM' : 'AM';
    var minutes = catchDate.getMinutes();
    hour = hour % 12;
    hour = hour ? hour : 12;
    minutes = minutes < 10 ? '0' + minutes : minutes;
    var dateString = hour + ':' + minutes + ':' + secs + '' + ampm;
    
    return dateString
  }

  nextVideo(currentVideo) {
    const videos = this.state.vidList;
    var i = videos.length - 1;
    var index = videos.indexOf(currentVideo);
    if(index !== i) {
      var next = index + 1;
    } else {
      var next = 0;
    }
    this.setState({
      currentVideo: videos[next]
    })
  }

  previousVideo(currentVideo) {
    const videolist = this.state.vidList;
    var i = videolist.length - 1;
    var index = videolist.indexOf(currentVideo);
    if(index !== i) {
      var previous = index - 1;
    } else {
      var previous = 0;
    }
    this.setState({
      currentVideo: videolist[previous]
    })
  }

  render () {
    if (this.state.redirect) {
      return <Redirect to='/videoplayer'/>;
  } 
    if(this.state.newFishLog.photoUrl) {
        var imageUrl = this.state.newFishLog.photoUrl;
      } else {
        var imageUrl = 'https://firebasestorage.googleapis.com/v0/b/sancochero-51ea9.appspot.com/o/default_boat.jpg?alt=media&token=b8c971f7-0a9b-4433-8516-ff0c7a3b7a7e';
      }
    if(this.state.newLog) {
      var popBox = 
          <div className="popContainer">
              <div
                id="boatContainer" 
                style={{
                  backgroundImage: 'url(' +  imageUrl  + ')',
                  flex: 1,
                  minHeight: '450px',
                  backgroundSize: 'cover',
                  backgroundRepeat: 'no-repeat',
                  backgroundPosition: '50% 50%',
                }}>
                  <div className="caughtBox">
                    <center> 
                      {this.state.newFishLog.catchDate ? 'CAUGHT FISH!!' : 'HOOKED UP'}
                    </center>
                  </div>
                  <div className="detailsBox">
                    <div 
                      className="speciesFlag" 
                      style={{
                        width: '100px',
                        height: '50px',
                        backgroundSize: 'cover',
                        backgroundRepeat: 'no-repeat',
                        backgroundPosition: '50% 50%',
                     //   backgroundImage: 'url(' +  this.state.speciesRaw[this.state.newFishLog.speciesId].speciesImageUri  + ')'
                      }}/>
                    <div className="boatNameContainer">
                      {this.state.newFishLog.boatName}
                    </div>
                    <div className="anglerName">
                      {this.state.newFishLog.anglerName}
                    </div>
                    <div className="dateBox">
                      {this.catchDate(this.state.newFishLog.catchDate)}
                    </div> 
                  </div> 
                  { this.state.newFishLog.fishLbs > 0 ? <div className="fishLbs">
                      {this.state.newFishLog.fishLbs} LBS.
                    </div> : null }
               </div>
            </div>
    } else {
      var popBox = null;
    }

    if(this.state.newLog) {
      var popMobileBox = 
          <div className="popContainer">
              <div
                id="boatMobileContainer" 
                style={{
                  backgroundImage: 'url(' +  imageUrl  + ')',
                  Height: '250px',
                  backgroundSize: 'cover',
                  backgroundRepeat: 'no-repeat',
                  backgroundPosition: '50% 50%',
                }}>
                  <div className="caughtBoxMobile">
                    <center> 
                      {this.state.newFishLog.catchDate ? 'CAUGHT FISH!!' : 'HOOKED UP'}
                    </center>
                  </div>
                  <div className="detailsBoxMobile">
                    <div 
                      className="speciesFlag" 
                      style={{
                        width: '80px',
                        height: '40px',
                        backgroundSize: 'cover',
                        backgroundRepeat: 'no-repeat',
                        backgroundPosition: '50% 50%',
                        backgroundImage: 'url(' +  this.state.speciesRaw[this.state.newFishLog.speciesId].speciesImageUri  + ')'
                      }}/>
                    <div className="boatNameContainerMobile">
                      {this.state.newFishLog.boatName}
                    </div>
                    <div className="anglerNameMobile">
                      {this.state.newFishLog.anglerName}
                    </div>
                    <div className="dateBoxMobile">
                      {this.catchDate(this.state.newFishLog.catchDate)}
                    </div>
                  </div> 
                    { this.state.newFishLog.fishLbs ? <div className="fishLbsPhone">
                      {this.state.newFishLog.fishLbs}
                    </div> : null }
               </div>
            </div>
    } else {
      var popMobileBox = null;
    }
    
    if(this.state.newLog) {
      var popBoxTv = 
          <div className="popContainer">
              <div
                id="boatTVContainer" 
                style={{
                  Height: '610px',
                  backgroundSize: 'cover',
                  backgroundRepeat: 'no-repeat',
                  backgroundPosition: '50% 50%',
                }}>
                  <div className="caughtBoxTv">
                    <center> 
                      {this.state.newFishLog.catchDate ? 'CAUGHT FISH!!' : 'HOOKED UP'}
                    </center>
                  </div>
                  <div className="detailsBoxTv">
                    <div 
                      className="speciesFlag" 
                      style={{
                        width: '80px',
                        height: '40px',
                        backgroundSize: 'cover',
                        backgroundRepeat: 'no-repeat',
                        backgroundPosition: '50% 50%',
                        backgroundImage: 'url(' +  this.state.speciesRaw[this.state.newFishLog.speciesId].speciesImageUri  + ')'
                      }}/>
                    <div className="boatNameContainerTv">
                      {this.state.newFishLog.boatName}
                    </div>
                    <div className="anglerNameTv">
                      {this.state.newFishLog.anglerName}
                    </div>
                    <div className="dateBoxTv">
                      {this.catchDate(this.state.newFishLog.catchDate)}
                    </div>
                  </div> 
                    { this.state.newFishLog.fishLbs > 0 ? <div className="fishLbsTv">
                      {this.state.newFishLog.fishLbs} LBS
                    </div> : null }
               </div>
            </div>
    } else {
      var popBoxTv = null;
    }
    var tourDay1a = moment.utc(this.state.tourDay1).format('dddd MMM Do, h:mm a');
    var tourDay2a = moment.utc(this.state.tourDay2).format('dddd MMM Do, h:mm a');
    return (
      <div className="main-containerDD" style={{backgroundImage: `url(${caboBkg})`, backgroundSize: 'cover'}}>
          <TelevisionBreakpoint>
            <div style={{zIndex: -1, display: this.state.loadingVis}}>
            <div className="scroller_rowTvPT">
                  <div className="headerBoxFullDD">
                    <div className="scoreRowTvPT2">
                      <div className='pelagicLogoTvPT' 
                      style={{
                        backgroundImage: 'url(https://firebasestorage.googleapis.com/v0/b/sancochero-51ea9.appspot.com/o/sponsors_logos%2Fmpvlogo.png?alt=media&token=f13448d3-8c6c-4006-8e9a-daaf03069d30)'
                      }} />
                    </div>
                    <div className="scoreRowTvPT">
                      <div className='tourLogoTvPT' 
                      style={{
                        backgroundImage: 'url(https://firebasestorage.googleapis.com/v0/b/sancochero-51ea9.appspot.com/o/doradoderby19.png?alt=media&token=c2480f59-4c90-4300-9ced-49a00ecb240b)'
                      }} />
                    </div>
                    <div className="scoreRowTvPT2">
                      <div className='pelagicLogoTvPT' 
                      style={{
                        backgroundImage: 'url(https://firebasestorage.googleapis.com/v0/b/sancochero-51ea9.appspot.com/o/sponsors_logos%2Fmpvlogo.png?alt=media&token=f13448d3-8c6c-4006-8e9a-daaf03069d30)'
                      }} />
                    </div>
                  </div> 
              </div>
              <div className="row2PT">
                 <div className="tvColumn1PT">
                   { popBoxTv }
                    <div style={{
                      display: this.state.displayVis,
                      width: '100%', 
                      justifyContent:'center', 
                      alignItems: 'center'}}>
                      <center>
                        <div className="videoContainer"> 
                          <ReactPlayer 
                            url={this.state.currentVideo}
                            controls={true}
                            width={'100%'}
                            height={610}
                            volume={.5}
                            muted={true}
                            playsinline={true}
                            youtube={{preload: true}}
                            onEnded={() => {
                              this.nextVideo(this.state.currentVideo)
                            }}
                            playing={this.state.vidPlaying}>
                          </ReactPlayer>
                        </div>
                      </center>
                    </div>
                </div>
                {this.state.logs.length > 0 ? <div className="logBoxPT">
                  <div className="logColumn">
                    {this.isEmpty(this.state.speciesRaw) ? null : <SpeciesScoresTVList logs={this.state.logs} speciesId={'-LN_cgZuA-J36ihIgdvO'} speciesName={'Dorado'} numSlides={5} /> }
                  </div>
                </div> : 
                <div style={{width: '45%'}}>
                  <div className="tourDetailsBox">
                    <div className="countBox">
                      <center>
                        <div className="countdownTitlePT">LIVE LEADERBOARDS</div>
                      </center>
                    </div>
                  <div className="tourDetails">
                        <div className="tourDetailsRow">
                          <div className="tourDetailsCol">
                            Registration
                          </div>
                          <div className="tourDetailsCol">
                            Friday Nov 1st, 2:00-6:00pm
                          </div>
                        </div>
                    </div>
                    <div className="tourDetails">
                        <div className="tourDetailsRow">
                          <div className="tourDetailsCol">
                            Day 1 Lines In
                          </div>
                          <div className="tourDetailsCol">
                          { tourDay1a }
                          </div>
                        </div>
                    </div>
                    <div className="tourDetails">
                        <div className="tourDetailsRow">
                          <div className="tourDetailsCol">
                            Weight Scale Hours
                          </div>
                          <div className="tourDetailsCol">
                            3PM - 6PM
                          </div>
                        </div>
                    </div> 
                  </div>
                </div> 
                }
              </div>
                <div style={{height: '150px'}}>
                 <SponsorsScrollerTv sponsors={ sponsorLogos } slides={4}/>
                </div>
              </div>
              <div className="loading" style={{width: '100%', height: '100%', display: this.state.loadingVis2}}>
                <div className="rowLoading">
                  <img src={this.state.tournamentLogo} width='50%' alt='Tournamant Logo'/>
                  </div>
              </div>
            </TelevisionBreakpoint>
          <DesktopBreakpoint>
            <div style={{zIndex: -1, display: this.state.loadingVis}}>
            <div className="scroller_rowTvPT">
                  <div className="headerBoxFull">
                    <div className="scoreRowTvPT2">
                      <div className='pelagicLogoTvPT' 
                      style={{
                        backgroundImage: 'url(https://firebasestorage.googleapis.com/v0/b/sancochero-51ea9.appspot.com/o/sponsors_logos%2Fmpvlogo.png?alt=media&token=f13448d3-8c6c-4006-8e9a-daaf03069d30)'
                      }} />
                    </div>
                    <div className="scoreRowTvPT">
                      <div className='tourLogoTvPT' 
                      style={{
                        backgroundImage: 'url(https://firebasestorage.googleapis.com/v0/b/sancochero-51ea9.appspot.com/o/doradoderby19.png?alt=media&token=c2480f59-4c90-4300-9ced-49a00ecb240b)'
                      }} />
                    </div>
                    <div className="scoreRowTvPT2">
                      <div className='pelagicLogoTvPT' 
                      style={{
                        backgroundImage: 'url(https://firebasestorage.googleapis.com/v0/b/sancochero-51ea9.appspot.com/o/sponsors_logos%2Fmpvlogo.png?alt=media&token=f13448d3-8c6c-4006-8e9a-daaf03069d30)'
                      }} />
                    </div>
                  </div> 
              </div>
              <div className="row2DTPT">
                 <div className="tvColumn">
                   { popBox }
                    <div style={{
                        display: this.state.displayVis,
                        width: '100%', 
                        justifyContent:'center', 
                        alignItems: 'center'
                       }}>
                        <center>
                          <div className="videoContainer">
                            <ReactPlayer 
                              url={this.state.currentVideo}
                              controls={true}
                              width={'100%'}
                              height={450}
                              volume={.5}
                              muted={false}
                              playsinline={true}
                              onEnded={() => {
                                this.nextVideo(this.state.currentVideo)
                              }}
                              playing={this.state.vidPlaying}>
                            </ReactPlayer>
                          </div>
                        </center>
                      </div>
                </div>
                {this.state.logs.length > 0 ? <div className="logBoxDTPT">
                <div className="logColumnDTPT">
                    {this.isEmpty(this.state.speciesRaw) ? null : <SpeciesScoresDTList logs={this.state.logs} speciesId={'-LN_cgZuA-J36ihIgdvO'} speciesName={'Dorado'} numSlides={5} /> }
                  </div>
                </div>  : <div style={{width: '45%'}}>
                  <div className="tourDetailsBoxPTDT">
                  <div className="countBox">
                    <center>
                    <div className="countdownTitlePTDT">LIVE LEADERBOARDS</div>
                    </center>
                  </div>
                  <div className="tourDetails">
                        <div className="tourDetailsRow">
                          <div className="tourDetailsColDT">
                            Registration
                          </div>
                          <div className="tourDetailsColDT">
                            Friday Nov 1st, 2:00-8:00pm
                          </div>
                        </div>
                    </div>
                    <div className="tourDetails">
                        <div className="tourDetailsRow">
                          <div className="tourDetailsColDT">
                            Day 1 Lines In
                          </div>
                          <div className="tourDetailsColDT">
                          { tourDay1a }
                          </div>
                        </div>
                    </div>
                    <div className="tourDetails">
                        <div className="tourDetailsRow">
                          <div className="tourDetailsColDT">
                            Weight Scale Hours
                          </div>
                          <div className="tourDetailsColDT">
                            3PM - 6PM
                          </div>
                        </div>
                    </div>
                    <div className="tourDetailsSignUp">
                      SIGN UP AT THE BAJA CANTINA
                    </div>
                  </div>
                </div> 
              }
              </div>
              </div>
              <div style={{height: '100px', backgroundColor: '#fff'}}>
                    <SponsorsScroller sponsors={ sponsorLogos } slides={4}/>
                  </div>
              <div className="loading" style={{width: '100%', display: this.state.loadingVis2}}>
                <div className="rowLoading">
                  <img src={this.state.tournamentLogo} width='50%' alt='Tournamant Logo'/>
                  </div>
              </div>
            </DesktopBreakpoint>
            <TabletBreakpoint>
              <div style={{display: this.state.loadingVis}}>
                <div style={{
                      flex: 1, 
                      height: '180px', 
                      backgroundSize: 'cover',
                      backgroundRepeat: 'no-repeat',
                      backgroundPosition: '50% 0%',
                      backgroundImage: 'url(https://firebasestorage.googleapis.com/v0/b/sancochero-51ea9.appspot.com/o/doradoderby19.png?alt=media&token=c2480f59-4c90-4300-9ced-49a00ecb240b)'}}>
                  <center>
                  <div className='tourLogoPhonePT' 
                      style={{
                        backgroundImage: 'url(https://firebasestorage.googleapis.com/v0/b/sancochero-51ea9.appspot.com/o/sponsors_logos%2Fmpvlogo.png?alt=media&token=f13448d3-8c6c-4006-8e9a-daaf03069d30)'
                      }} />
                  </center>
                </div>
                
                  {this.state.boatScores.length > 0 ? null : 
                    <div style={{flex: 1, height: '140px', marginBottom: '5px'}}>
                    <div className="countBox">
                      <center>
                      <div className="countdownTitlePhone">LIVE LEADERBOARDS</div>
                        <div className="countdownTitlePhone">Countdown to Lines In</div>
                          <Countdown 
                            date={this.state.countDownDate}
                            renderer={props => 
                              <div className="countDownRow">
                                <div className="countDownBoxPhone">{props.days} <br />Days</div>
                                <div className="countDownBoxPhone">{props.hours}<br />Hrs</div>
                                <div className="countDownBoxPhone">{props.minutes}<br />Mins</div>
                                <div className="countDownBoxPhone">{props.seconds}<br />Secs</div>
                              </div>
                            }
                             /> 
                        </center>
                      </div>
                    </div>
                    }
                
                  <div className="tvColumn">
                    { popMobileBox }
                    <div style={{
                      display: this.state.displayVis, 
                      width: '100%', 
                      justifyContent:'center', 
                      alignItems: 'center'}}>
                      <center>
                        <div className="videoContainer"> 
                          <ReactPlayer
                            url={this.state.currentVideo}
                            controls={true}
                            width={'100%'}
                            height={350}
                            volume={.5}
                            muted={false}
                            playsinline={true}
                            onEnded={() => {
                              this.nextVideo(this.state.currentVideo)
                            }}
                            playing={this.state.vidPlaying}>
                          </ReactPlayer>
                        </div>
                      </center>
                    </div>
                  </div>
                  <div style={{height: '100px', backgroundColor: '#fff'}}>
                    <SponsorsScroller sponsors={ sponsorLogos } slides={3}/>
                  </div>
                  {this.state.logs.length > 0 ?<div className="speciesRowTabPT">
                  {this.isEmpty(this.state.speciesRaw) ? null : <SpeciesScoresTabList logs={this.state.logs} speciesId={'-LN_cgZuA-J36ihIgdvO'} speciesName={'Dorado'} /> }
                </div> : null}
                  {this.state.fishLogs.length > 0 ? null:
                    <TournamentDetailsPhone tournament={this.state.tournament} />
                  }
              </div>}
              <div className="loading" style={{width: '100%', display: this.state.loadingVis2}}>
                <div className="rowLoading">
                  <img src={this.state.tournamentLogo} width='50%' alt='Tournament Logo'/>
                  </div>
              </div>
            </TabletBreakpoint>
            <PhoneBreakpoint>
            <div style={{display: this.state.loadingVis}}>
            <center>
              <img src={this.state.tournamentLogo} width='50%' alt='Tournament Logo'/>
            </center>
                  {this.state.boatScores.length > 0 ? null : 
                    <div style={{flex: 1, marginBottom: '5px'}}>
                    <div className="countBox">
                      <center>
                        <div className="countdownTitlePhone">LIVE LEADERBOARDS</div>
                      </center>
                      </div>
                    </div>
                    }
                  <div className="tvColumn">
                    { popMobileBox }
                    <div style={{
                      display: this.state.displayVis, 
                      width: '100%', 
                      justifyContent:'center', 
                      alignItems: 'center'}}>
                      <center>
                        <div className="videoContainer"> 
                          <ReactPlayer
                            url={this.state.currentVideo}
                            controls={true}
                            width={'100%'}
                            height={350}
                            volume={.5}
                            muted={false}
                            playsinline={true}
                            onEnded={() => {
                              this.nextVideo(this.state.currentVideo)
                            }}
                            playing={this.state.vidPlaying}>
                          </ReactPlayer>
                        </div>
                      </center>
                    </div>
                  </div>
                  <div style={{height: '100px', backgroundColor: '#fff'}}>
                    <SponsorsScroller sponsors={ sponsorLogos } slides={3}/>
                  </div>
                  {this.state.logs.length > 0 ?<div className="speciesRowTabPT">
                  {this.isEmpty(this.state.speciesRaw) ? null : <SpeciesScoresTabList logs={this.state.logs} speciesId={'-LN_cgZuA-J36ihIgdvO'} speciesName={'Dorado'} /> }
                </div> : null}
                  {this.state.fishLogs.length > 0 ? null:
                    <TournamentDetailsPhone tournament={this.state.tournament} />
                  }
              </div>}
              <div className="loading" style={{width: '100%', display: this.state.loadingVis2}}>
                <div className="rowLoading">
                  <img src={this.state.tournamentLogo} width='50%' alt='Tournament Logo'/>
                  </div>
              </div>
            </PhoneBreakpoint>
          { this.state.playing ? <Sound
              url={dragSound}
              playStatus={this.state.playing}
              />: null }
      </div> 
    );
  }
}

export default DoradoDerby;


// WEBPACK FOOTER //
// ./src/pages/tournaments/DoradoDerby.js